import { render, staticRenderFns } from "./Temperatures.vue?vue&type=template&id=f3173120&scoped=true&"
import script from "./Temperatures.vue?vue&type=script&lang=js&"
export * from "./Temperatures.vue?vue&type=script&lang=js&"
import style0 from "./Temperatures.vue?vue&type=style&index=0&id=f3173120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3173120",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VCol,VContainer,VRow,VSelect,VSpacer})
